/**
 * @param {object} item
 * @return {string}
 */
export const defaultKeyGet = item => item.id || item._id;
